import Close from "shared/components/utils/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { ThemeProvider } from "@material-ui/core/styles";
import Theme from "app/styles/Theme";
import { createGlobalStyle } from "styled-components";

const SidebarGlobalStyles = createGlobalStyle`
    .slide-pane__header {
        display: flex;
        flex: 0 0 3rem;
        align-items: center;
        background-color: inherit;
        height: auto;
        border-bottom: none;
    }
    .slide-pane__close {
        right: 1rem;
        padding: 0;
        opacity: 1;
        position: absolute;
    }
    .slide-pane__content {
        padding: 0 0 2.5em 0;
        overflow-y: unset;
    }
    .slide-pane__title-wrapper {
        margin-left: 0rem;
        padding-top: 0.8rem;
    }
    .no-overlay {
        left: inherit;
        width: 32%;
    }
    .no-overlay.slide-pane__overlay.overlay-after-open {
        background-color: transparent;
        z-index: 999;
    }
    .sliding-pane-custom {
        box-shadow: -15px 0px 50px 0px rgba(0, 0, 0, 0.12);
    }
    .slide-pane__close svg {
        width: 16px;
    }
`;

const GenericSidebar = ({
    open,
    content,
    onClose,
    title,
    includeTheme = true,
    ...props
}) => {
    const handleRequestClose = () => {
        onClose();
    };

    const outerContent = (
        <div className={props.className} id="sidebarGenericContent">
            <SidebarGlobalStyles />
            {props.children}
            <SlidingPane
                className="sliding-pane-custom"
                overlayClassName="no-overlay"
                isOpen={open}
                title={title}
                subtitle=""
                closeIcon={
                    <Close color={globalThis.config.colors.gray2} size="16" />
                }
                width="100%"
                s
                onRequestClose={handleRequestClose}
            >
                {content}
            </SlidingPane>
        </div>
    );

    return includeTheme ? (
        <ThemeProvider theme={Theme}>{outerContent}</ThemeProvider>
    ) : (
        outerContent
    );
};

GenericSidebar.propTypes = {
    open: PropTypes.bool,
    content: PropTypes.node,
    onClose: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    includeTheme: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};

export default GenericSidebar;
